export default "__VITE_PUBLIC_ASSET__dcc657ec__"